<template>
  <div class="content">
    <div class="content-main">
      <p class="content-title">身份证审核</p>
      <div class="content-input">
        <div class="content-input-item">
          <label>性别：</label>
          <el-select v-model="sex" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in sexArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>公开性：</label>
          <el-select v-model="openState" placeholder="Select" style="width: 8em">
            <el-option v-for="item in openStateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>进入情况：</label>
          <el-select v-model="enterType" placeholder="Select" style="width: 8em">
            <el-option v-for="item in enterTypeArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>状态：</label>
          <el-select v-model="state" placeholder="Select" style="width: 8em">
            <el-option v-for="item in stateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>身份信息：</label>
          <el-select v-model="isOcrSuccess" placeholder="请选择" size="mini" style="width: 9em;">
            <el-option v-for="item in isOcrSuccessArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>年龄信息：</label>
          <el-select v-model="isAgeAbnormal" placeholder="请选择" size="mini" style="width: 9em;">
            <el-option v-for="item in isAgeAbnormalArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>身份证重复：</label>
          <el-select v-model="isRepeat" placeholder="请选择" size="mini" style="width: 9em;">
            <el-option v-for="item in isRepeatArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <DatePickerRange title="时间：" @date="getTime($event)" @check="getCheck($event)" :isChecked="isChecked"/>
        </div>
        <div class="content-input-item">
          <SearchComponents :searchTypeList="searchTypeList" :searchType="searchType"  :searchValue="searchValue" @searchType="getSearchType($event)" @searchValue="getSearchValue($event)" />
          <el-checkbox v-model="limitState" :true-label="1" :false-label="0" style="margin-left: 8px;">有限制</el-checkbox>
        </div>
        <div class="content-input-item">
          <ElButtons type="primary" icon="search" @click="getPage(true)" v-loading="searchLoading"> 查询 </ElButtons>
          <ElButtons icon="RefreshLeft" @click="refreshParam"> 重置 </ElButtons>
        </div>
      </div>
    </div>
    <div class="content-main">
      <div class="content-button">
        <div style="display: flex; align-items: center;">
          <ElButtons icon="Comment" @click="sendSysMsg">发送通知</ElButtons>
          <el-button @click="allCheck" v-if="!isAllCheck">全选</el-button>
          <el-button @click="noAllCheck" type="danger" v-if="isAllCheck">取消全选</el-button>
          <el-button type="danger" @click="batchReject">批量不通过</el-button>
          <el-button type="primary" @click="batchPass" v-loading="passLoading">批量通过</el-button>
        </div>
<!--        <BtnGroup :tableRef="$refs.multipleTableRef" :colList="colList" @colListChange="colListChange($event)" @refresh="getPage"></BtnGroup>-->
      </div>
      <div class="content-table">
        <div v-loading="listLoading">
          <el-space wrap v-if="pageDataList.length > 0" :size="16">
            <div v-for="(item, index) in pageDataList" :key="item.id" class="space-item">
              <div class="item-box">
                <div class="list-item">
                  <el-image class="item-img" fit="fill" :src="item.headImg.smallHeadImg" @click="isCheckChange(index)"><template #error><div class="el-img-error">暂无图片</div></template></el-image>
                  <div class="check-icon" v-if="item.check"><i class="fa fa-check fa-lg" aria-hidden="true"></i></div>
                  <div class="scale-icon" @click.prevent="showImg(index)"><i class="fa fa-arrows-alt" aria-hidden="true"></i></div>

                  <el-popover placement="top" :width="220" trigger="click">
                    <template #reference>
                      <div class="info-icon"><i class="fa fa-user fa-lg" aria-hidden="true"></i></div>
                    </template>
                    <div style="padding: 8px; line-height: 1.7">
                      <UserInfoList :row="item" showList="name,phone,uid,city"/>
                      <p>时间：{{item.createTime}}</p>
                      <p>进入情况: {{item.enterType==0?'免费进入':item.enterType==1?'邀请码进入':item.enterType==2?'认证费用':item.enterType==3?'保证金进入+认证费用':item.enterType==4?'保证金+邀请码':item.enterType==5?'直接进入':item.enterType==6?'芝麻认证进入':item.enterType==7?'身份证直接进入':item.enterType==null?'未进入':''}}</p>
                      <p>状态：{{item.identityState==0?'未提交':item.identityState==1?'待审核':item.identityState==2?'审核通过':item.identityState==3?'审核不通过':item.identityState==4?'手持正面认证不通过':item.identityState==5?'身份证正面不通过':''}}</p>
                      <p style="color: red" v-if="item.isNonage">未成年</p>
                    </div>
                  </el-popover>
                </div>
                <div class="item-box-log cursor" @click="updateUserLog(item)">
                  <p class="box-log-title">用户日志</p>
                  <div style="display: flex; align-items: center;margin: 16px;flex: 1;">
                    <div style="width: 100%" v-if="item.userLogList.length > 0">
                      <span>{{item.userLogList[0].createTime}}</span>
                      <p><span style="margin-right: 10px; ">{{item.userLogList[0].content}}</span><el-tag size="small">{{item.userLogList[0].name}}</el-tag></p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="line">
                <el-image class="item-img" fit="fill" :src="item.imgZ" @click="identityExamine(item)"><template #error><div class="el-img-error">暂无图片</div></template></el-image>
                <div class="item-box-bottom">
                  <div class="bottom-list" v-if="item.ocrIdCardFront">
                    <p class="box-title">身份证识别信息</p>
                    <p><span style="margin-right: 8px">实名：{{ item.ocrIdCardFront.name }}</span><el-button type="danger" size="small" @click="repeat(item)" v-show="item.isRepeat == 1">身份证号码重复</el-button><el-button type="primary" size="small"  v-show="item.isRepeat == 2">因注销导致身份证重复</el-button></p>
                    <p>身份证号码：{{ item.ocrIdCardFront.idNumber }}</p>
                    <p>识别时间：{{ item.ocrTime }}</p>
                  </div>
                </div>
              </div>
              <div>
                <el-image class="item-img" fit="fill" :src="item.imgF" @click="identityExamine(item)"><template #error><div class="el-img-error">暂无图片</div></template></el-image>
                <div class="item-box-bottom">
                  <div class="bottom-list">
                    <p class="box-title">身份展示信息</p>
                    <p>实名：{{ item.identityName }}</p>
                    <get-plain title="身份号码：" :code="item.identityCode" :uid="item.uid" :type="10" :subType="1"/>
                    <p>更新时间：{{ item.identityUpdateTime }}</p>
                  </div>
                </div>
              </div>
            </div>
          </el-space>
          <el-empty v-else description="没有更多数据"></el-empty>
        </div>
        <el-pagination background layout="total, prev, pager, next, jumper" :total="totalRow" :page-size="pageSize" :current-page="currentPage" @current-change="handleCurrentChange">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import DatePickerRange from '../../components/DatePickerRange'
import SearchComponents from '../../components/SearchComponents'
// import BtnGroup from '../../components/BtnGroup'
import {
  getIdentityQuicklyPageList, updateIdentityState,
} from '../../api/url'
import { getFormData, postJson, postFormData } from '../../api/api'
import Dialog from '../../assets/js/dialog'
import SendSystemMessage from "@/components/SendSystemMessage";
import UserLogDialog from '../../components/UserLog/UserLogDialog'
import ImgViewer from '../../assets/js/imageViewer'
import {common, auth, identity} from "@/assets/shared/select-constant";
import UserLog from "@/components/UserLog/UserLog";
import GetPlain from "@/components/resume/GetPlain";
import IdentityRejectDialog from "./components/identity/IdentityRejectDialog";
import IdentityExamine from "./components/identity/IdentityExamine";
import RepeatDialog from "./components/identity/RepeatDialog";


export default {
  name: "ReviewIdentityFast",
  components: { DatePickerRange, SearchComponents, UserLog, GetPlain },
  data() {
    return {
      sexArray: common.sexList,
      sex: common.sexList[2]['value'],

      overallAuthStateArray: auth.overallAuthStateList,
      overallAuthState: auth.overallAuthStateList[0]['value'],


      //公开
      openStateArray: [
        {label: '不限', value: -1},
        {label: '待补全信息', value: 0},
        {label: '待公开', value: 1},
        {label: '公开-手动', value: 2},
        {label: '不公开-手动', value: 3},
        {label: '公开-头像机审', value: 4},
        {label: '不公开-头像机审', value: 5},
      ],
      openState: 0,


      //进入情况
      enterTypeArray: identity.enterTypeList,
      enterType: identity.enterTypeList[0]['value'],


      //状态
      stateArray: identity.stateList,
      state: identity.stateList[1]['value'],

      passLoading: false,

      //身份信息
      isOcrSuccessArray: [
        {label: '不限', value: -1},
        {label: '识别成功', value: 1},
        {label: '识别失败', value: 2},
        {label: '未识别', value: 0},
      ],
      isOcrSuccess: 1,

      //年龄信息
      isAgeAbnormalArray: [
        {label: '不限', value: -1},
        {label: '正常', value: 1},
        {label: '异常', value: 2},
        {label: '未判断', value: 0}
      ],
      isAgeAbnormal: -1,

      //身份证重复
      isRepeatArray: [
        {label: '不限', value: -1},
        {label: '重复', value: 1},
        {label: '不重复', value: 0},
      ],
      isRepeat: -1,

      limitState: 0,


      //时间
      startTime: '',
      endTime: '',
      isChecked: true,

      //搜索
      searchTypeList: [
        {label : '手机号', value : 1},
        {label : '昵称', value : 2},
        {label : '用户ID', value : 3},
        {label : '用户日志', value : 4},
        {label : '身份证号', value : 5},
        {label : '身份证名', value : 6},
        {label : '邀请码', value : 7},
      ],
      searchType: 3,
      searchValue: '',

      //刷新组
      colList: ['认证时间','提交时间', '头像', '用户信息', '进入情况', '期望结婚时间', '身份证照片', '实名信息', '身份认证状态', '芝麻认证', '百度认证', '总状态', '用户日志'],
      checkColList: [],

      pageDataList: [],
      currentPage: 1,
      totalRow: 0,
      pageSize: 20,
      listLoading: false,
      searchLoading: false,
      updateLoading: false,

      //选中id
      idArray: [],
      userIdArray: [],
      //选中性别
      userSexArray: [],


      //是否全选
      isAllCheck: false,

    }
  },
  methods: {

    idenStartChange() {
      if(this.authType == -1) {
        this.idenStateArray = [{label: '不限', value: -1}];
        this.idenState = -1;
      } else if(this.authType == 1) {
        this.idenStateArray = identity.stateList;
        this.idenState = -1;
      } else if(this.authType == 2 || this.authType == 3) {
        this.idenStateArray = [
          {label: '不限', value: -1},
          {label: '审核通过', value: 1},
          {label: '审核不通过', value: 0}
        ];
        this.idenState = -1;
      }
    },

    getTime(val) {
      this.startTime = val[0];
      this.endTime = val[1];
      // console.log(val)
    },
    getCheck(val) {
      this.isChecked = val
    },
    getSearchType(e) {
      this.searchType = e;
      // console.log(e)
    },
    getSearchValue(e) {
      this.searchValue = e;
      // console.log(e)
    },
    // 展示表格的列
    colListChange(val) {
      this.checkColList = val;
    },
    // 重置参数
    refreshParam() {
      this.isChecked = true;
      this.sex = 2;
      this.openState = 0;
      this.limitState = 0;
      this.enterType = -1;
      this.isOcrSuccess = 1;
      this.isAgeAbnormal = -1;
      this.isRepeat = -1;
      this.state = 1;
      this.startTime = '';
      this.endTime = '';
      this.searchValue = '';
      setTimeout(()=> {
        this.getPage(true);
      }, 500)
    },
    // //分页
    // handleCurrentChange(val) {
    //   this.currentPage = val;
    //   this.getPage();
    // },

    // //获取选中id
    // selsChange(sels) {
    //   this.idArray = sels.map(item => item.userId);
    // },
    //
    // //全选
    // selsAll(column, event) {
    //   if(column.type == 'selection') {
    //     let array = this.idArray;
    //     if(array.length == this.pageDataList.length) {
    //       array = [];
    //     }
    //     this.pageDataList.forEach(item => {
    //       if(array.indexOf(item.userId) === -1) {
    //         this.$refs.multipleTableRef.toggleRowSelection(item);
    //       }
    //     })
    //   }
    // },

    showImg(idx) {
      let imgList = []
      for(let i=0; i<this.pageDataList.length; i++) {
        imgList.push(this.pageDataList[i].headImg.headImg)
      }
      ImgViewer.open({
        imgList: imgList,
        imgIndex: idx
      })
    },

    //全选
    allCheck(){
      this.isAllCheck = true;
      for(let i=0;i<this.pageDataList.length;i++){
        this.pageDataList[i]['check'] = true;
      }
    },

    //取消全选
    noAllCheck() {
      this.isAllCheck = false;
      for(let i=0;i<this.pageDataList.length;i++){
        this.pageDataList[i]['check'] = false;
      }
    },

    //选中状态
    isCheckChange(idx) {
      this.pageDataList[idx]['check'] = !this.pageDataList[idx]['check'];
      // this.$set(this.pageDataList, idx, this.pageDataList[idx]);
    },

    //分页
    handleCurrentChange(val) {
      this.isAllCheck = false;
      this.currentPage = val;
      this.getPage();
    },

    //批量操作id
    imageCheckIds(){
      this.idArray = [];
      for (let i = 0; i < this.pageDataList.length; i++) {
        if (this.pageDataList[i]['check']) {
          this.idArray.push(this.pageDataList[i].userId)
        }
      }
    },

    getPage(reset) {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        if(reset) {
          this.currentPage = 1;
        }
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['sex'] = this.sex;
      param['enterType'] = this.enterType;
      param['openState'] = this.openState;
      param['state'] = this.state;
      param['ocrSuccess'] = this.isOcrSuccess;
      param['ageAbnormal'] = this.isAgeAbnormal;
      param['isRepeat'] = this.isRepeat;
      param['limitState'] = this.limitState;
      param['startTime'] = this.startTime;
      param['endTime'] = this.endTime;
      param['searchType'] = this.searchType;
      param['searchValue'] = this.searchValue;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(getIdentityQuicklyPageList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          this.totalRow = result['total'];
          this.pageSize = result['size'];
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch((response) => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },


    //图片预览

    // showImg(img) {
    //   let imgList = []
    //   imgList.push(img)
    //   ImgViewer.open({
    //     imgList
    //   })
    // },

    toggleSelection(row, column, cell, event) {

      if(column.type == 'selection') {
        this.$refs.multipleTableRef.toggleRowSelection(row)
      }

      //更新用户日志
      if(column.label == '用户日志') {

      }

    },

    updateUserLog(row){
      Dialog.open({
        title: '用户日志',
        component: UserLogDialog,
        data: {
          id: row.userId
        },
        close: () => {
          row['userLogList'] = JSON.parse(sessionStorage.getItem('userLog'));
        }
      })
    },

    identityExamine(row) {
      let identityForm = Object.assign({}, row);
      Dialog.open({
        title: '身份证审核',
        component: IdentityExamine,
        data: {
          identityForm: identityForm,
          width: '1300px'
        },
        confirm: () => {
          for(let i = 0; i < this.pageDataList.length; i++) {
            if(row.userId == this.pageDataList[i].userId) {
              this.pageDataList.splice(i, 1);
            }
          }
        }
      })
    },


    //发送系统消息
    sendSysMsg() {
      this.imageCheckIds()
      if(this.idArray.length == 0) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请至少选择一条记录进行操作',
          type: 'warning'
        })
        return false
      }
      Dialog.open({
        title: '发送小助手通知',
        component: SendSystemMessage,
        data: {
          userIdArray: this.idArray,
          width: '600px'
        },
        confirm: () => {
          this.isAllCheck = false;
        }
      })
    },


    batchReject() {
      this.imageCheckIds()
      if(this.idArray.length > 0) {
        Dialog.open({
          title: '不通过原因',
          component: IdentityRejectDialog,
          data: {
            idArray: this.idArray,
            width: '500px'
          },
          confirm: () => {
            for(let j=0;j<this.idArray.length;j++) {
              for(let i=0;i<this.pageDataList.length;i++) {
                if(this.pageDataList[i]['userId'] == this.idArray[j]) {
                  this.pageDataList.splice(i,1);
                  i--;
                }
              }
            }
            if(this.pageDataList.length == 0) {
              this.getPage(false);
            }
            this.isAllCheck = false;
          }
        })
      } else {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请至少选择一位用户进行专区操作',
          type: 'warning'
        })
      }
    },

    batchPass() {
      let _this = this
      _this.imageCheckIds()
      if(_this.idArray.length > 0) {
        _this.$confirm('确认选中的用户？').then(() => {
          _this.passLoading = true;
          let param = {};
          param['idArr'] = _this.idArray;
          param['state'] = 2;
          param['isRepeat']  = 0;
          postFormData(updateIdentityState,param).then(function(data){
            let {code,msg} = data;
            if(code == 200){
              _this.$message({
                showClose: true,
                duration: 1000,
                message: msg,
                type: 'success'
              });
              for(let j=0;j<_this.idArray.length;j++) {
                for(let i=0;i<_this.pageDataList.length;i++) {
                  if(_this.pageDataList[i]['userId'] == _this.idArray[j]) {
                    _this.pageDataList.splice(i,1);
                    i--;
                  }
                }
              }
              if(_this.pageDataList.length == 0) {
                _this.getPage(false);
              }
            }else{
              _this.$message({
                showClose: true,
                duration: 1000,
                message: msg,
                type: 'warning'
              })
            }
            _this.passLoading = false;
            _this.isAllCheck = false;
          })
                  .catch(function(response){
                    _this.passLoading = false;
                    _this.isAllCheck = false;
                  })
        })
      } else {
        _this.$message({
          showClose: true,
          duration: 1000,
          message: '请至少选择一位用户进行专区操作',
          type: 'warning'
        })
      }
    },

    //身份证号码重复
    repeat(row) {
      let identityForm = Object.assign({}, row);
      Dialog.open({
        title: '新认证用户的身份证号码已存在',
        component: RepeatDialog,
        data: {
          identityForm: identityForm,
          width: '800px'
        },
        confirm: (result) => {

        }
      })
    },



  },
  mounted() {
    this.$nextTick(function() {
      this.checkColList = this.colList;
    })
    this.getPage();
    this.idenStartChange();
  }
}
</script>

<style scoped>
.playBtn {
  font-size: 5em;
  color: #c0c4cc;
  cursor: pointer;
}
.playBtn:hover {
  font-size: 5em;
  color: #3a8ee6;
}
.space-item{
  display: flex;
  font-size: 12px;
  line-height: 1.5;
  border: 0.02em solid #ebeef5;
}
  .item-img {
    width: 250px;
    height: 250px;
  }
  .item-box-bottom {
    width: 250px;
    margin-top: 6px;
  }
  .bottom-list {
    margin: 0 12px;
    width: 100%;
  }
  .item-box-log {
    display: flex;
    /*height: 90px;*/
    width: 250px;
  }
  .line{
    border-left: 0.02em solid #ebeef5;
    border-right: 0.02em solid #ebeef5;
  }
  .box-title{
    font-weight: bold;
    margin-bottom: 4px;
  }
  .box-log-title{
    font-weight: bold;
    writing-mode:tb-rl;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 40px;
    height: 100px;
    border-right: 0.02em solid #ebeef5;
    letter-spacing: 2px;
  }
.list-item {
  position: relative;
  cursor: pointer;
  width: 250px;
  height: 250px;
}
.check-icon {
  position: absolute;
  width: 40px;
  height: 40px;
  top: 105px;
  left: 105px;
  background-color: #409eff;
  border-radius: 50%;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
}
.scale-icon {
  position: absolute;
  right: 16px;
  bottom: 16px;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background-color: rgba(0,0,0,0.3);
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
}
.scale-icon:hover {
  background-color: rgba(0,0,0,0.8);
}

.info-icon {
  position: absolute;
  left: 16px;
  bottom: 16px;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background-color: rgba(0,0,0,0.3);
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
}
.info-icon:hover {
  background-color: rgba(0,0,0,0.8);
}
</style>
